export default __webpack_public_path__ + "static/media/elements_assets.8a9e02f3.png";